// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".exam-duration[data-v-03aba44d] {\n  padding-top: 4px;\n  font-size: 14px;\n}\n.canvas-element-exam[data-v-03aba44d] {\n  padding-left: 16px;\n  padding-right: 16px;\n}", ""]);
// Exports
module.exports = exports;
